const COMMON_IMAGE_ACCEPTS = [".jpg", ".jpeg", ".png", ".tif", ".tiff"];

function buildAcceptList(...accepts: string[]) {
  const merged = new Set<string>();

  for (const accept of COMMON_IMAGE_ACCEPTS) {
    merged.add(accept);
  }

  for (const accept of accepts) {
    for (const token of accept.split(",")) {
      const value = token.trim();
      if (value) {
        merged.add(value);
      }
    }
  }

  return Array.from(merged).join(",");
}

export const uploadAccepts = {
  productPictures: buildAcceptList(".3ds", ".obj", ".fbx", ".glb", ".gltf", ".stl", ".step", ".stp", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".mp4", ".zip", ".rar", ".psd"),
  product3dFiles: buildAcceptList(".3ds", ".obj", ".fbx", ".glb", ".gltf", ".stl", ".step", ".stp", ".pdf", ".zip", ".rar", ".psd"),
  userManual: buildAcceptList(".pdf", ".doc", ".docx", ".ppt", ".pptx", ".zip", ".rar", ".psd"),
  certificates: buildAcceptList(".pdf", ".doc", ".docx"),
  packagingDiecutArtwork: buildAcceptList(".pdf", ".doc", ".docx", ".ppt", ".pptx", ".zip", ".rar", ".psd"),
  outlineImages: buildAcceptList(".stp", ".step", ".pdf", ".ppt", ".pptx", ".zip", ".rar", ".psd"),
  priceStructure: buildAcceptList(".pdf", ".doc", ".docx", ".xls", ".xlsx", ".csv", ".ppt", ".pptx", ".zip", ".rar"),
  productVideo: buildAcceptList(".3ds", ".obj", ".fbx", ".glb", ".gltf", ".stl", ".step", ".stp", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".mp4", ".zip", ".rar", ".psd"),
  supplierProfile: buildAcceptList(".jpg", ".jpeg", ".png", ".tif", ".tiff", ".pdf", ".ppt", ".pptx", ".doc", ".docx", ".xls", ".xlsx", ".zip", ".rar", ".7z"),
} as const;

export const submissionContent = {
  header: {
    title: "New Product Submission",
    description: `
This form is designed for one Single Product Submission.
If you wish to propose more that one product, Fill separate form for Every New Product.

Do not upload low-resolution or unclear images.
We require clean, professional product visuals wherever images are used.
`.trim(),
  },

  submissionDate: {
    title: "Submission Date *",
    placeholder: "DD / MM / YYYY",
  },

  productInfo: {
    title: "Product Information",
    fields: {
      model: "1. Product Model Name or Code. *",
      overview: {
        label: "2. Product Description and Overview *",
        hint: "Tell us about your product, the idea, the benefits, what makes it special, etc...",
      },
      specs: {
        label: "3. Product Technical Specs *",
        hint: "Please confirm technical specifications with your engineering team before submitting.",
      },
      features: {
        label: "4. Product Features and Compatibility *",
        hint: "Please write your Product features and unique sales points in details",
      },
      materials: {
        label: "5. Made of Materials *",
        hint: "List the Raw Material used to make this products by Name, Type and Code etc..",
      },
      packaging: {
        label: "6. Retails Packaging Content *",
        hint: "What comes with the product in the retail packaging? please list them one by one.",
      },
      markets: "7. Major Markets (Countries) you are selling this Product to? *",
      brands: "8. Brand Names that are buying this product from you with their websites and product names *",
    },
  },

  uploads: {
    title: "Files and Documents Uploads",
    items: [
      {
        name: "product_pictures",
        label: "1. Product Pictures",
        hint: `Accepts: ${uploadAccepts.productPictures}`,
      },
      {
        name: "product_3d_files",
        label: "2. Product 3D drawing files",
        hint: `Accepts: ${uploadAccepts.product3dFiles}`,
      },
      {
        name: "user_manual",
        label: '3. User Manual "English, Chinese and other available language"',
        hint: `Accepts: ${uploadAccepts.userManual}`,
      },
      {
        name: "certificates",
        label: "4. All Available Certificate such as CE/CB/FCC/ROHS/APX/THX/Dolby/Etc...",
        hint: `Accepts: ${uploadAccepts.certificates}`,
      },
      {
        name: "packaging_diecut_artwork",
        label: "5. Retail Packaging Die-cut and Artwork files.",
        hint: `Accepts: ${uploadAccepts.packagingDiecutArtwork}`,
      },
      {
        name: "outline_images",
        label: "6. Outline image of the product from all sides (Ai or PDF).",
        hint: `Accepts: ${uploadAccepts.outlineImages}`,
      },
      {
        name: "price_structure",
        label: "7. Price Structure",
        hint: `Accepts: ${uploadAccepts.priceStructure}`,
      },
      {
        name: "product_video",
        label: "8. Product Supporting Files",
        hint: `Accepts: ${uploadAccepts.productVideo}`,
      },
    ],
  },

  supplier: {
    title: "Supplier Company and Contact Person Details",
    companyName: "1. Supplier Company Name *",
    profile: "2. Supplier Company Profile *",
    profileHint: `Accepts: ${uploadAccepts.supplierProfile}`,
    contactName: "3. Supplier Contact Person Name *",
    email: "4. Supplier Contact Person Email ID *",
    mobile: "5. Supplier Contact Person Mobile Number and Wechat ID *",
  },

  footer: {
    messageTitle: "Any message you would like to leave for us?",
    thankYou: `
Thank you for your submission. We value your input and welcome
feedback, suggestions, or concerns you may have.

Email: Mukka@ayyantech.net
WeChat ID: mukka-nomi
WhatsApp: +8615818552554
`.trim(),
  },
};
